<template>
    <div class="content">
        <div v-for="(block, i) in blocks">
            <component
                :is="block.component"
                :content="block.content"
                :enrollment="enrollment"
                :component="component"
                :data="data"
                @save="(d) => $emit('save', d)"
            ></component>
        </div>
    </div>
</template>

<script>
    import OneColumnText from "./OneColumnText";
    import TwoColumnText from "./TwoColumnText";
    import ThreeColumnText from "./ThreeColumnText";
    import ExpanderText from "./ExpanderText";
    import FlipCards from "./FlipCards";
    import Video from "./Video";
    import PhotoAndText from "./PhotoAndText";
    import TextField from "./TextField";
    import TextArea from "./TextArea";
    import CheckBox from "./CheckBox";
    import DropdownField from "./DropdownField";
    import StudyRecordLog from "./StudyRecordLog";

    export default {
        name: "RenderBlocks",
        components: {OneColumnText, TwoColumnText, ThreeColumnText, ExpanderText, FlipCards, Video, PhotoAndText, TextField, TextArea, CheckBox, DropdownField, StudyRecordLog},
        props: {
            blocks: {
                required: true
            },
            data: {
                type: Object
            },
            component: {},
            enrollment: {}
        },
        data: function() {
            return {

            }
        },
        methods: {

        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        margin-left: 12px;
        margin-bottom: 2rem;
    }
</style>
